
import { gql } from '@apollo/client'

/**
 * Get products details by searchTerm.
 */
 export const GET_PRODUCTS_BY_SEARCH_TERM = gql`
 query GET_PRODUCTS_BY_SEARCH_TERM($storeId: String!, $langId: String!, $searchTerm: String!, $pageSize: String!,  $pageNumber: String!) {
  productViewFindProductsBySearchTerm(storeId: $storeId, langId: $langId, searchTerm: $searchTerm, pageSize: $pageSize, pageNumber:  $pageNumber) {
    recordSetStartNumber
    recordSetCount
    recordSetTotal
    recordSetTotalMatches
    facetView {
        name
        value
        extendedData {
            srchattridentifier
        }
        entry {
            count
            label
            value
            extendedData{
                parentIds
            }
        }
    }
    catalogEntryView {
        name
        shortDescription
        partNumber
        uniqueID
        thumbnail
        parentCatalogGroupID
        attributes {
            identifier
            uniqueID
            usage
            values {
                value
            }
        }
    }
  }
 }
 `;
